/* eslint-disable max-lines-per-function */
import classNames from 'classnames'
import { useCallback, useEffect } from 'react'
import { ListItemV3, TDesktopDropDownOverlay } from './types/types'
import Text from '@/stories/components/Common/NewText'
import HeaderListItem from './HeaderListItem'

type TProps = {
  isOpen: boolean
  onClose?: () => void
  list1?: ListItemV3
  list2?: ListItemV3
  section: TDesktopDropDownOverlay
}

const DropdownOverlayChildV3 = ({
  isOpen,
  onClose = () => {},
  list1,
  list2,
  section,
}: TProps) => {
  const handleFirstScroll = useCallback(() => {
    onClose()
    // Remove event listener after firing once
    window.removeEventListener('scroll', handleFirstScroll)
  }, [onClose])

  useEffect(() => {
    if (isOpen) {
      window.addEventListener('scroll', handleFirstScroll)
    }

    return () => {
      window.removeEventListener('scroll', handleFirstScroll)
    }
  }, [handleFirstScroll, isOpen])
  const getHeading = () => {
    switch (section) {
      case 'Disclosure':
        return 'Disclosure'
      default:
        return null
    }
  }

  const Heading = getHeading()
  return (
    <section
      className={classNames('w-full py-5', {
        'flex flex-col justify-center': isOpen,
        hidden: !isOpen,
      })}
    >
      {Heading && (
        <Text appearance="subtitle2" addClassName="pb-2 text-base pl-6">
          {Heading}
        </Text>
      )}

      <nav className="flex w-full flex-row items-start">
        {list1 && (
          <HeaderListItem
            listElement={list1}
            addClassNames={`gap-2 ${list2 ? 'w-3/5' : 'w-full'} ${
              list1.addClassNames ? list1.addClassNames : ''
            } `}
            listItemClasses="px-6"
            onClose={onClose}
          />
        )}
        {list2 && (
          <HeaderListItem
            listElement={list2}
            addClassNames={`gap-0 border-brand-grey-light border-l-[0.5px] w-2/5 ${
              list2.addClassNames ? list2.addClassNames : ''
            }`}
            listItemClasses="pl-6"
            onClose={onClose}
          />
        )}
      </nav>
    </section>
  )
}

export default DropdownOverlayChildV3
